var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-32 md:py-48 text-center"},[_c('SvgIcon',{class:['mb-4 w-24 h-24 mx-auto', _vm.iconClasses],attrs:{"name":_vm.icon}}),_vm._v(" "),_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.content),expression:"content"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }